import isEnteringViewport from './_element-entering-view';

const applyCSSAnimations = {

    elements: [],

    applyAnimations()
    {
        const elements = [];

        this.elements.forEach( element  => {
            
            const visible = isEnteringViewport(element);
            
            if( visible )
            {
                element.classList.add(element.getAttribute('data-active-class'));
            }
            else
            {
                elements.push( element );
            }
        });

        this.elements = elements;
    },

    cacheDom() 
    {
        const elements = [];
        const fadeIn = document.querySelectorAll('.fade-in');
        const scaleIn = document.querySelectorAll('.scale-in');
        const vertIntoView = document.querySelectorAll('.vert-into-view');
        const zoomOut = document.querySelectorAll('.zoom-out');

        if( fadeIn )
        {
            fadeIn.forEach( element => {
                element.setAttribute('data-active-class', 'fade-in--active');
                elements.push(element);
             });
        }
        
        if( scaleIn )
        {
            scaleIn.forEach( element => {
                element.setAttribute('data-active-class', 'scale-in--active');
                elements.push(element);
            });
        }
        
        if( vertIntoView )
        {
            vertIntoView.forEach( element => {
                element.setAttribute('data-active-class', 'vert-into-view--active');
                elements.push(element);
            });
        }

        if( zoomOut )
        {
            zoomOut.forEach( element => {
                element.setAttribute('data-active-class', 'zoom-out--active');
                elements.push(element);
            });
        }

        this.elements = elements;
    },

    bind()
    {
        window.addEventListener('scroll', () => {
            this.applyAnimations();
        });
        
        this.applyAnimations();
    },

    init() 
    {
        this.cacheDom();
        this.bind();
    }

}

export default applyCSSAnimations;